/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const connections = (state = defaultState.connections, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        connections = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.CONNECTION_LIST:
                nextState = action.payload;
                break;

            case constants.CONNECTION_SHOW:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.CONNECTION_UPDATE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.CONNECTION_DELETE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) !== parseInt(action.payload.id, 10)) {
                        connections.push(nextState[i]);
                    }
                }
                nextState = connections;
                break;

            case constants.CONNECTION_CREATE:
                nextState.push(action.payload);
                break;

            default:
                break;
        }
    }

    return nextState;
};
